<template v-slot:no-data xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-btn color="primary">Gösterilecek Veri Bulunmamaktadır...</v-btn>
</template>
<script>
export default {
  name: 'NoDataAvailable',
};
</script>
